import React from 'react';
import EditorialVideoContainer from './EditorialVideoContainer';
const EditorialVideoWrapper = (props) => {
    const IS_FULLBLEED = props.dimension === 'FULL_BLEED';
    const colClasses = {
        '16_COLUMNS': 'col-lg-16 offset-lg-4',
        '20_COLUMNS': 'col-lg-20 offset-lg-2',
        FULL_BLEED: '',
    };
    const wrapperClasses = {
        '16_COLUMNS': 'editorial-video--wrapper--16',
        '20_COLUMNS': 'editorial-video--wrapper--20',
        FULL_BLEED: 'editorial-video--wrapper--full',
    };
    const renderWrapper = () => (React.createElement("div", { className: `editorial-video--wrapper ${wrapperClasses[props.dimension]}` },
        React.createElement("div", { className: `container` },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: colClasses[props.dimension] }, props.ratio === '3:4' ? React.createElement("div", { className: "centered-3-4" }, renderVideo()) : renderVideo())))));
    const renderVideo = () => React.createElement(EditorialVideoContainer, Object.assign({}, props, { isFullbleed: IS_FULLBLEED }));
    return React.createElement(React.Fragment, null, IS_FULLBLEED ? renderVideo() : renderWrapper());
};
export default EditorialVideoWrapper;
